require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-tanzania-roads-to-inclusion-and-socio-economic-opportunities.json") })
        }
      }, "path---en-us-project-tanzania-roads-to-inclusion-and-socio-economic-opportunities");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-tanzania-roads-to-inclusion-and-socio-economic-opportunities!./.cache/json/en-us-project-tanzania-roads-to-inclusion-and-socio-economic-opportunities.json
// module id = 564
// module chunks = 231608221292675